import OrgProfileContainer from './OrgProfileContainer';

export default OrgProfileContainer;
